import React from 'react'
import PropTypes from 'prop-types'
import {TriggerWithTooltip} from '#components/m/MeineAzubis/TriggerWithTooltip'

export default function FeedbackTitle({originalFilename}) {
  return (
    <TriggerWithTooltip text={originalFilename} modifiers={['dark', 'nopadding']}>
      <span>{originalFilename}</span>
    </TriggerWithTooltip>
  )
}

FeedbackTitle.propTypes = {
  originalFilename: PropTypes.any,
}
